import React from 'react';
import PropTypes from 'prop-types';

function CustomRowComponentContainer({
  customComponent = {},
  className = '',
  data = [],
  metadataColumns = [],
  globalData = {},
  style,
}) {
  if (typeof customComponent !== 'function') {
    return <div className={className} />;
  }

  const CustomComponent = customComponent;

  return (
    <div className={className} style={style}>
      {data.map((row, index) => {
        return (
          <CustomComponent
            data={row}
            metadataColumns={metadataColumns}
            key={`CustomRowComponentContainer_CustomComponent_${index}`}
            globalData={globalData}
          />
        );
      })}
    </div>
  );
}

CustomRowComponentContainer.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  showPager: PropTypes.bool,
  pagingContent: PropTypes.object,
  style: PropTypes.string,
};

export { CustomRowComponentContainer };
